export default __webpack_public_path__ + "static/media/step_1_open_app.cbeef161.png";